import { useTranslation } from "react-i18next";

const Description = ({ mode }: { mode: string }) => {
  const { t } = useTranslation();

  const textColor = mode === "light" ? "text-black" : "text-white";

  return (
    <div className={`mt-3 ${textColor} text-base md:pb-2 flex flex-col gap-2 md:gap-3 overflow-hidden text-center`}>
      <div className="overflow-y-auto min-h-0 hide-scrollbar">
        <p
          dangerouslySetInnerHTML={{
            __html: t(`${mode}ChoiceDescription`),
          }}
        />
        <p className="mt-2">{t(`${mode}ChoiceDisclaimer`)}</p>
      </div>
    </div>
  );
};

export default Description;
